var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import { ProblemBusiness } from '@business/newCreateRequest/stepsItems/problem';
import SvgImage from "../svgImage";
import { createForm } from 'rc-form';
import { Button, Dragger, Form, Loader, TextArea } from 'oned';
import '../../details/detailStep.less';
import { AmplitudeEventName, StepType } from "@common/enums/base";
import PubSub from "@common/utils/pubsub";
import { getCurrentEnv, getLocationId, sendAmplitude_Default } from "@common/utils";
var FormItem = Form.FormItem;
var additionalDetailPlaceholder = "More information on what's happening. Write about sounds, smells, or details that will help the technician prepare…";
var DuplicateOriginWO = inject(ProblemBusiness)(observer(function (props) {
    var form = props.form, originWO = props.originWO, duplicateDeleteAttachment = props.duplicateDeleteAttachment, currentUser = props.currentUser, clientId = props.clientId;
    var _a = useState(originWO), tempWO = _a[0], setTempWO = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(false), isEditAttachment = _c[0], setIsEditAttachment = _c[1];
    var _d = useState(false), isEditDescription = _d[0], setIsEditDescription = _d[1];
    var getFieldError = form.getFieldError;
    var getError = function (field) {
        var error = getFieldError(field);
        return error ? error.join(",") : "";
    };
    var handleAdditionalDetail = function (value) {
        if (tempWO.additionalDetail !== value) {
            setIsEditDescription(true);
        }
        tempWO.additionalDetail = value;
        setTempWO(tempWO);
    };
    var uploadEvent = function (files) {
        var duplicateUploadAttachment = props.duplicateUploadAttachment;
        setLoading(true);
        return new Promise(function (resolve) {
            if (!files.length) {
                resolve(true);
                setLoading(false);
            }
            if (files.length <= 10) {
                var uploadFailCount_1 = 0;
                var uploadCount_1 = 0;
                files.map(function (file) { return __awaiter(void 0, void 0, void 0, function () {
                    var item;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, duplicateUploadAttachment(file, tempWO)];
                            case 1:
                                item = _a.sent();
                                uploadCount_1++;
                                if (!item) {
                                    uploadFailCount_1++;
                                }
                                if (uploadFailCount_1 === files.length) {
                                    resolve(false);
                                    showNotification("You have " + uploadFailCount_1 + " " + (uploadFailCount_1 > 1 ? 'files' : 'file') + " upload error.");
                                }
                                else if (uploadCount_1 === files.length) {
                                    resolve(true);
                                    uploadFailCount_1 && showNotification("You have " + uploadFailCount_1 + " " + (uploadFailCount_1 > 1 ? 'files' : 'file') + " upload error.");
                                }
                                if (uploadCount_1 === files.length) {
                                    setLoading(false);
                                    setIsEditAttachment(true);
                                }
                                return [2 /*return*/];
                        }
                    });
                }); });
            }
            else {
                showNotification("Upload up to 10 attachments at one time.");
                resolve(false);
            }
        });
    };
    var editAttachmentsAmplitude = function () {
        sendAmplitude_Default(AmplitudeEventName.RSPDuplicate_EditAttachment, {
            env: getCurrentEnv(),
            userId: currentUser.userId,
            residentId: currentUser.residentId,
            locationId: getLocationId(),
            clientId: clientId,
        });
    };
    var showNotification = function (content) {
        window.notificationManager.show({
            title: "Something was wrong !",
            type: "primary",
            position: "top-right",
            content: content,
        });
    };
    var handleDisable = function () {
        return tempWO.additionalDetail ? !tempWO.additionalDetail.trim() : true;
    };
    var scrollTop = function () {
        PubSub.notify('scrollto', 0);
    };
    var goNextStep = function () { return __awaiter(void 0, void 0, void 0, function () {
        var jump, serviceCategoryId, serviceTypeId, serviceCodeId, duplicateSubmit, params;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    jump = props.jump, serviceCategoryId = props.serviceCategoryId, serviceTypeId = props.serviceTypeId, serviceCodeId = props.serviceCodeId, duplicateSubmit = props.duplicateSubmit;
                    return [4 /*yield*/, form.validateFields()];
                case 1:
                    _a.sent();
                    setLoading(true);
                    params = {
                        duplicateWO: {
                            locationId: getLocationId(),
                            originalWOReactiveId: tempWO.woId,
                            serviceCategoryId: serviceCategoryId,
                            serviceTypeId: serviceTypeId,
                            serviceCodeId: serviceCodeId
                        },
                        attachments: tempWO.attachments,
                        additionalDetail: tempWO.additionalDetail
                    };
                    duplicateSubmit(params).then(function (data) {
                        if (!data.isSuccess) {
                            showNotification(data.message);
                        }
                        else {
                            jump(StepType.DuplicateOriginWOSubmitted);
                            isEditAttachment && editAttachmentsAmplitude();
                            isEditDescription && sendAmplitude_Default(AmplitudeEventName.RSPDuplicate_EditDescription, {
                                env: getCurrentEnv(),
                                userId: currentUser.userId,
                                residentId: currentUser.residentId,
                                locationId: getLocationId(),
                                clientId: clientId,
                            });
                        }
                    }).catch(function () {
                        showNotification('Please try agin.');
                    }).finally(function () {
                        setLoading(false);
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var deleteWOAttachment = function (index) {
        setLoading(true);
        duplicateDeleteAttachment(index, tempWO).then(function () {
            setLoading(false);
            setIsEditAttachment(true);
        });
    };
    useEffect(function () {
        scrollTop();
        initPageData();
    }, []);
    var initPageData = function () {
        setIsEditAttachment(false);
        setIsEditDescription(false);
    };
    return React.createElement(React.Fragment, null,
        React.createElement(Loader, { page: true, visible: loading }),
        React.createElement("div", { className: 'dsm-card rsp-step-details' },
            React.createElement("div", { className: 'dsm-card-body' },
                React.createElement("div", { className: "pb-5" },
                    React.createElement("div", { className: "svc-title" },
                        React.createElement("b", null,
                            "WO #",
                            tempWO.woId)),
                    React.createElement("div", { className: "f16 mt-3" },
                        React.createElement("b", null, "We are currently reviewing the details of your request.")),
                    React.createElement("div", { className: "f16 mt-3" },
                        React.createElement("b", null, "You can add additional details to the original description and attachments. "))),
                React.createElement("div", { className: 'detail-service-combination d-flex align-items-center' },
                    tempWO.serviceCombinationAliasId ?
                        React.createElement(SvgImage, { iconUrl: tempWO.serviceCombinationAlias.serviceCodeIconUrl, prefixCls: "sc-icon-mr" }) :
                        React.createElement(SvgImage, { iconUrl: '', prefixCls: "sc-icon-mr" }),
                    React.createElement("b", { className: "svc-title" }, tempWO.aliasOrServiceComboName),
                    React.createElement("br", null)),
                React.createElement(React.Fragment, null,
                    React.createElement("p", { className: "form-item-title mt-4" }, "Description"),
                    React.createElement(FormItem, { error: getError("additionalDetail") },
                        React.createElement(TextArea, __assign({ placeholder: additionalDetailPlaceholder, "data-one-uiautomation": "rsp-step-details-additionalDetail", className: "additional-detail-input" }, form.getFieldProps('additionalDetail', {
                            initialValue: tempWO.additionalDetail,
                            onChange: function (e) { return handleAdditionalDetail(e.target.value); },
                            rules: [{ max: 500, message: 'Please enter no more than 500 characters.' }]
                        }))))),
                React.createElement("div", { className: "attachment-view" },
                    React.createElement("p", { className: "form-item-title mt-5 f22" }, "Attachments"),
                    React.createElement(Dragger, { multiple: true, fileList: tempWO.attachments, onUpload: function (files) { return uploadEvent(files); }, onRemove: function (index) { return deleteWOAttachment(index); }, maxSize: 1024 * 1024 * 50, accept: ".3gp,.avi,.rmvb,.rm,.mp4,.mov,.m4a,.amr,.mp3,.wav,.wma,.asf,.mpg,.mpeg,.vob,.jpg,.jpeg,.peg,.png,.gif,.bmp,.svg,.heif,.heic,.hevc,.mkv" })))),
        React.createElement(Button, { type: "primary", disabled: handleDisable(), className: "w-100 my-4 dsm-btn-primary dsm-btn", onClick: goNextStep }, "Submit"));
}));
export default createForm()(DuplicateOriginWO);
